import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NgFor, NgIf } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { getSidebarForModule, OSMAPages } from '@app/enums';
import { PermissionService } from '@app/_services/permission.service';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { UtilityService } from '@app/_services/utility.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NgIf, NgFor, NzMenuModule, RouterLink, NzFlexModule, ScrollingModule, NzTooltipModule],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input() isCollapsed: boolean = false;
  utilityService = inject(UtilityService);
  router = inject(Router);
  sideBarlist: any = [];

  constructor(private permService: PermissionService) {
    let currentModule: string = this.utilityService.getModuleName();
    let sidebarList: any = getSidebarForModule(currentModule);
    this.sideBarlist = sidebarList.filter((item: any) => {
      //temp
      if (item.pathName === OSMAPages.ALERTS || item.pathName === OSMAPages.ACCOUNT_INTAKE) {
        return item;
      }
      if (this.permService.hasPageAccess(currentModule, item.pathName)) {
        return item;
      }
    });
  }

  isActive(path: string): boolean {
    // forward slash / is to fix the issue with advisor getting highlighted when on advisor-dashboard.
    const url = `${this.router.url}/`;
    return url.includes(`${path}/`);
  }
}
